import { SET_USERS_LIST} from "./listUsersActions";

const INITIAL_STATE = {
  users: null,

};

const listUsersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USERS_LIST:
      return {
        ...state,
        users: action.payload,
      };



    default:
      return state;
  }
};

export default listUsersReducer;
